import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-sms-new-sms-dashboard',
  templateUrl: './sms-new-sms-dashboard.component.html',
  styleUrls: ['./sms-new-sms-dashboard.component.scss']
})
export class SmsNewSmsDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-sms', 'sms-page.new sms', '/account/smss', [new BRoute('account-page.account', '/account'), new BRoute('sms-page.smss', '/account/smss'), new BRoute('sms-page.new sms')]));
  }

}
